export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-paw-70f64beadc304fb3cbbc73a56f02a955.svg";